import * as aliyunConfig from "@config/aliyun.config.js";
import axios from "axios";
import qs from 'qs'
import storage from "../assets/js/storage";
export const MyMixin = {
  data() {
    return {
      timer: null,
      versionSip: "0.5.0",
      versionAgentbar: "1.11.0",
      versionworkBench: "2.7.0",
    }
  },
  methods:{
    clearInter() {
      let vm = this;
      // clearInterval(vm.timer);
      // vm.createInter();
    },
    createInter() {
      var ajaxPath =
          process.env.NODE_ENV != "LOCAL"
              ? aliyunConfig.ajaxPath
              : aliyunConfig.ajaxPathDev;
      let vm = this;
      this.timer = setInterval(() => {
        var str = "";
        for (var i = 0; i < 7; i += 1) {
          str += Math.floor(Math.random() * 10);
        }
        var Myhttp = axios.create({
          headers: {
            "Content-Type":
                "application/x-www-form-urlencoded;charset=utf-8;boundary =" +
                str,
            "jwt": storage.getStorage("jwt")
          },
        });
        let data = {
          request: {instanceId: `${aliyunConfig.aliyunInstance}`},
        };
        Myhttp.post(
            ajaxPath + "?action=RefreshToken",
            qs.stringify({
              request: JSON.stringify({
                instanceId: `${aliyunConfig.aliyunInstance}`,
              }),
            })
        )
            .then(function (res) {
              console.log("手动刷新success path:login/318==>", res);
            })
            .catch(function (err) {
              clearInterval(vm.timer);
              console.log("手动刷新error path:login/318===>", err);
            });
      }, 10000);

    // }, 20 * 60 * 1000);
    },
    aliyunLogin(cb) {
      if(localStorage.getItem('seatType') == 2) {
        cb()
      }else {
        if(window.workbench) {
          cb()
        }else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.initAliyunCall()
              .then((result) => {
                console.log('result',result);
                if(result) {
                  this.clearInter();
                  loading.close();
                  cb()
                }
              })
        }
      }

    },
    async loadScripts() {
      const cssURL =
          "https://g.alicdn.com/cloudcallcenter/web-workbench-sdk/" +
          this.versionworkBench +
          "/main.min.css";
      const scripts = [
        "https://g.alicdn.com/cloudcallcenter/SIPml/" +
        this.versionSip +
        "/SIPml-api.js",
        "https://g.alicdn.com/cloudcallcenter-voip/web-agentbar-sdk/" +
        this.versionAgentbar +
        "/index.js",
        "https://g.alicdn.com/cloudcallcenter/web-workbench-sdk/" +
        this.versionworkBench +
        "/workbenchSdk.min.js",
      ];

      // 加载CSS
      const linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "stylesheet");
      linkTag.href = cssURL;
      const header = document.getElementsByTagName("head");
      if (header.length) {
        header[0].appendChild(linkTag);
      } else {
        document.documentElement.appendChild(linkTag);
      }

      // 加载Scripts
      for (const item of scripts) {
        await this.loadScript(item);
      }
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = false; // 同步加载
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.body.appendChild(script);
      });
    },

    initAliyunCall() {
      if(localStorage.getItem('seatType') == 2) {
        return new Promise(resolve => {
          resolve(true)
        })
      }else {
        var vm = this;
        // aliyun register 回调
        var firstLoad = true;
        let loading = this.$loading({
          lock: true,
          text: '正在登录账号，请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        function registerSuccessHandle() {
          loading.close();
          vm.$message({
            type: "success",
            message: "登陆云中心成功，可以进行工作了",
          });
        }
        // 数据收集起来
        function aliyunCallHandle(code, detail, error) {
          if (code === "LogOut") {
            console.log("logout4");
            var checktimeOut = localStorage.getItem("checkSystemTimer");
            checktimeOut && window.clearTimeout(checktimeOut);
            console.log("detail1", error);
            // vm.$confirm(`${detail.errorMsgTip}`, '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     vm.$router.replace('/login')
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消'
            //     });
            // });
          } else if (code === "ErrorNotify") {
            console.log("detail", detail);
            // vm.errorHandle({messaeg: detail && detail.errorMsgTip})
            // vm.$message.error(detail.errorMsgTip)
            vm.$confirm(`${detail.errorMsgTip}`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
                .then(() => {
                  vm.$router.replace("/login");
                })
                .catch(() => {
                  vm.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
          } else if (code === "StatusChange") {
            vm.$store.commit('setWorkBenchCallStatus',arguments[1].code)
            //第一次 空闲时 ，只能外呼
            // console.log("status change ", arguments, arguments[1]);
            console.log("sssssss ", arguments[1]);
            if (arguments[1].code == 3) {
              vm.$message.success('可拨号')
              // vm.$message.success('可拨号')
              // window.pubsub && window.pubsub.emit("call-applyForCallOnly");
              //window.workbench&&window.workbench.applyForCallOnly(isCallOnly);// 设置做坐席是否外呼
              firstLoad = false;
            }
            // TODO  从 0 => 1   注册中 -> 签出，给个提示
            // 因为如果耳机失效的话，这个值是可能产生，
            // 2种情况，情况1：有值从0=>1 ， 证明是未注册成功，会一直停留在登录页面，旋转
            // 情况2： 可以注册成功后，控制台报错，但是没有错误提示
            if (arguments[1].code === 4) {
              vm.$message.success('可拨号')
              // 发送一个 去休息的状态
              //window.pubsub && window.pubsub.emit('ƒ');
              // window.workbench.ready();
            }
          } else if (code === "CallComing") {
            console.log("来电了... ", arguments);
            window.pubsub.emit("call-back", arguments);
          } else if (code === "CallDialing") {
            console.log("去电.... ", arguments,22222222222);
            localStorage.setItem("callingPhoneNumber", arguments[1].callee);
            window.pubsub && window.pubsub.emit("callDialing");
            if (arguments[arguments.length - 1]) {
              window.pubsub.emit(
                  "call-setContactId",
                  arguments[arguments.length - 1]
              );
            }
          } else if (code === "CallEstablish") {
            console.log("这里是通话建立时触发的回调函数", arguments);
            window.pubsub && window.pubsub.emit("CallEstablish");
          } else if (code === "CallRelease") {
            window.pubsub.emit("call-hang-up", arguments[1]);
            window.pubsub && window.pubsub.emit("callOver");
          } else if (code === "HangUp") {
            // console.log(
            //         //dialing 对方未接听挂机 可能是坐席挂 也有可能对方自动挂 outbound 对方挂断 也有可能自己挂断
            //   "这里是通话挂断时触发的回调函数",
            //   arguments,
            //   arguments[1]
            // );
            // window.pubsub.emit("call-hang-up", arguments[1]);
            // window.pubsub && window.pubsub.emit("callOver");
          }
        }

        return new Promise((resolve, reject) => {
          console.log(window.workbench);
          if (window.workbench) {
            window.workbench = null;
          }else {
            this.loadScripts()
                .then(() => {
                  let vm = this;
                  // var ajaxPath=process.env.NODE_ENV === 'LOCAL'?aliyunConfig.ajaxPathDev:aliyunConfig.ajaxPath
                  var ajaxPath =
                      process.env.NODE_ENV != "LOCAL"
                          ? aliyunConfig.ajaxPath
                          : aliyunConfig.ajaxPathDev;
                  var config = {
                    dom: "CallCenter",
                    useOpenApiSdk: false,
                    instanceId: aliyunConfig.aliyunInstance,
                    width: "280px",
                    height: "552px",
                    ajaxPath: ajaxPath,
                    ajaxHeaders: {
                      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8;",
                      "jwt": localStorage.getItem("jwt")
                    },
                    ajaxMethod: "post",
                    afterCallRule: aliyunConfig.afterCallRule,
                    header: true,
                    autoAnswerCall: aliyunConfig.autoAnswerCall,
                    exportErrorOfApi: true,
                    moreActionList: ["mobilePhoneAnswer", "break", "offline"],
                    customizedNotification: true,
                    // SDK对象实例化完成时触发
                    onInit: function () {
                      window.workbench.register(); // 想实现自动上线在此注册
                    },
                    // 注册成功后
                    onRegister: function (config) {
                      console.log("注册成功 ... ");
                      loading.close()
                      // registerSuccessHandle();
                      resolve(true);
                    },
                    onErrorNotify: function (error) {
                      console.log("发生error", error);
                      loading.close()
                      if (error.errorCode == '8001') {
                        console.log(1111);
                        vm.$alert('请检查耳机或麦克风接口是否正确插入', '提示', {
                          confirmButtonText: '确定',
                        });
                      }

                      // this.
                      // aliyunCallHandle('ErrorNotify', error);
                    },
                    onLogOut: function (error) {
                      console.log("312321", error);
                      aliyunCallHandle("LogOut", ...arguments);
                    },
                    onLogIn: function (error) {
                      aliyunCallHandle("LogIn", ...arguments, error);
                    },
                    // 小休时触发
                    onBreak: function () {
                      aliyunCallHandle("Break", ...arguments);
                    },
                    onReady: function () {
                      aliyunCallHandle("Ready", ...arguments);
                    },
                    // 状态 改变 值
                    onStatusChange: function (code, lastCode, context) {
                      aliyunCallHandle("StatusChange", ...arguments);
                    },
                    // 来电时触发
                    onCallComing: function (
                        connid,
                        caller,
                        calee,
                        contactId,
                        skillgroupId
                    ) {
                      console.log("电话前状态=====》", window.workbench.getStatusCode());
                      aliyunCallHandle("CallComing", {
                        connid,
                        caller,
                        calee,
                        contactId,
                        skillgroupId,
                      });
                    },
                    // 去电、拨号振铃时触发
                    onCallDialing: function (connid, caller, calee, contactId) {

                      console.log(
                          "去电了================》",
                          connid,
                          caller,
                          calee,
                          contactId
                      );
                      localStorage.setItem("startTime", new Date().valueOf())
                      aliyunCallHandle("CallDialing", ...arguments);
                      // 清除可能存在的上一次计时器
                      if (vm.dialingTimer) {
                        clearTimeout(vm.dialingTimer);
                      }
                      // 设置40秒超时检测
                      vm.dialingTimer = setTimeout(() => {
                        if (window.workbench && window.workbench.getStatusCode().code === 8) { // 8表示坐席是呼叫中
                            window.workbench.hangUp();
                            vm.$message.warning('无人接听，已自动挂断');
                        }
                      }, 40000);
                    },
                    // 通话建立连接触发
                    onCallEstablish: function (connid, caller, calee, contactId) {
                      // 清除拨号超时计时器
                        if (vm.dialingTimer) {
                          clearTimeout(vm.dialingTimer);
                      }
                      console.log(
                          "通话建立连接触发=============>",
                          connid,
                          caller,
                          calee,
                          contactId
                      );
                      localStorage.setItem("contactTime", new Date().valueOf())
                      aliyunCallHandle("CallEstablish", ...arguments);
                    },
                    // 通话结束
                    onCallRelease: function (connid, caller, calee, contactId) {

                      // 清除拨号超时计时器
                      if (vm.dialingTimer) {
                        clearTimeout(vm.dialingTimer);
                      }

                      aliyunCallHandle("CallRelease", ...arguments);
                    },
                    // 挂机时触发
                    onHangUp: function (type) {
                      if (vm.dialingTimer) {
                        clearTimeout(vm.dialingTimer);
                      }
                      aliyunCallHandle("HangUp", ...arguments);
                    },
                  };
                  // 这个环境 是 developement
                  if (
                      process.env.NODE_ENV === "development" ||
                      process.env.NODE_ENV === "production"
                  ) {
                    config.ajaxPath = aliyunConfig.ajaxPath;
                  }
                  window.workbench = new window.WorkbenchSdk(config);
                  window.workbench.changeVisible(false);
                  window.workbench.checkNetwork();

                  if (!window.workbench) {
                    reject(false);
                  }
                })
          }

        });
      }
    },
  }
}
